import React, { useCallback, useState } from 'react';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../routing/helpers/router';
import colors from '../../../../../constants/colors';
import errorHandler from '@/layout/components/error/ErrorHandler';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import Translator from '../../../../components/helpers/Translator';

export default function ResetFuturePrevisions({
  resourceObligationID,
  elementID,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  // > RECALCULATE PREVISIONS
  const recalculatePrevisions = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_resourceManager_resourceObligation_prevision_recalculate"
          ),
          {
            moduleBridgeHex,
            resourceObligationID,
          }
        )
        .then(() => {
          setShowModal(false);
          dispatch(currentPageAction.change("updateCard", elementID, true));
          dispatch(
            currentPageAction.change(
              "updateResourceObligationTab",
              elementID,
              true
            )
          );
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, resourceObligationID]
  );
  // < RECALCULATE PREVISIONS

  return (
    <>
      <AppRemixIcon
        icon="refresh"
        color={colors.primary}
        onClick={() => setShowModal(true)}
        title={ReactDOMServer.renderToString(
          <Translator file="module-resourceManager" name="resource.settings" />
        )}
        className="pointer"
      />
      <AppModal
        title={
          <Translator file="module-resourceManager" name="resource.settings" />
        }
        show={showModal}
        onClose={() => setShowModal(false)}
      >
        <p>
          <Translator
            file="module-resourceManager"
            name="resource.want.recalculate.future.periods"
          />
          <br />
          <br />
          <Translator
            file="module-resourceManager"
            name="resource.action.cannot.undone"
          />
          .
        </p>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => recalculatePrevisions()}
        >
          <Translator
            file="module-resourceManager"
            name="resource.recalculate"
          />
        </button>
      </AppModal>
    </>
  );
}
